
export class ScrollLock {

    static setScrollLockActive(lockActive: boolean) {
        if (lockActive) {
          this.disableBodyScroll()
        } else {
          this.enableBodyScroll()
        }
    }

    // =============================
    // Touch scroll lock
    private static preventDefault(e: TouchEvent){
        e.preventDefault();
    }
    private static disableBodyScroll() {
        document.body.addEventListener('touchmove', ScrollLock.preventDefault, { passive: false });
    }
    private static enableBodyScroll() {
        document.body.removeEventListener('touchmove', ScrollLock.preventDefault);
    }
    // =============================

    // =============================
    // Momentum detection
    private static momentumDetectionActive = false
    private static lastScrollTime = 0
    private static scrollDelta = 0
    private static readonly MOMENTUM_THRESHOLD = 80 // pixels
    private static readonly TIME_WINDOW = 150 // milliseconds
    private static momentumCheckTimeout: number | null = null

    static enableMomentumDetection() {
        if (this.momentumDetectionActive) return

        this.momentumDetectionActive = true
        this.scrollDelta = 0
        this.lastScrollTime = Date.now()
        window.addEventListener('wheel', this.onWheel, { passive: true })
    }

    static disableMomentumDetection() {
        if (!this.momentumDetectionActive) return

        this.momentumDetectionActive = false
        window.removeEventListener('wheel', this.onWheel)

        if (this.momentumCheckTimeout !== null) {
            clearTimeout(this.momentumCheckTimeout)
            this.momentumCheckTimeout = null
        }

        this.scrollDelta = 0
    }

    private static onWheel = (e: WheelEvent) => {
        if (!ScrollLock.momentumDetectionActive) return

        const now = Date.now()
        const timeDiff = now - ScrollLock.lastScrollTime

        // Only track upward scrolling (negative deltaY)
        if (e.deltaY >= 0) {
            ScrollLock.scrollDelta = 0
            ScrollLock.lastScrollTime = now
            return
        }

        // Reset if time window exceeded
        if (timeDiff > ScrollLock.TIME_WINDOW) {
            ScrollLock.scrollDelta = 0
        }

        ScrollLock.scrollDelta += Math.abs(e.deltaY)
        ScrollLock.lastScrollTime = now

        // Check if threshold reached
        if (ScrollLock.scrollDelta >= ScrollLock.MOMENTUM_THRESHOLD) {
            ScrollLock.emitMomentumEvent()
            ScrollLock.scrollDelta = 0
        }

        // Clear timeout if exists
        if (ScrollLock.momentumCheckTimeout !== null) {
            clearTimeout(ScrollLock.momentumCheckTimeout)
        }

        // Reset delta after time window
        ScrollLock.momentumCheckTimeout = window.setTimeout(() => {
            ScrollLock.scrollDelta = 0
            ScrollLock.momentumCheckTimeout = null
        }, ScrollLock.TIME_WINDOW)
    }

    private static emitMomentumEvent() {
        const event = new CustomEvent('scrolllock-momentum-threshold')
        window.dispatchEvent(event)
    }
    // =============================
}